<template>
  <div id="confirmacao-sucesso">
    <div class="detalhe-consulta">
      <strong style="margin-bottom: 8px; display: block;">Responsável</strong>
      <GrupoFamiliarBeneficiario
        v-if="beneficiarioSelecionado === null"
        v-model="beneficiarioSelecionado"
        id-funcionalidade="53"
        :numero-contrato="numeroContrato || $route.query.contrato"
      />
      <StepFormulario v-else :paciente="beneficiarioSelecionado" @submit="submitForm"/>
      <div v-if="beneficiarioSelecionado === null">
        <strong>Legenda</strong> <br/>
        <ul class="caption-list">
          <li>
            <i class="material-icons-outlined icon" style="color:#09B531">
              mobile_friendly
            </i>
            Pessoa já possui o app instalado
          </li>
          <li>
            <i class="material-icons-outlined icon" style="color:#888888">
              block
            </i>
            Não pode ser selecionado
          </li>
        </ul>
        <p>
          <strong>Informações:</strong> {{ textos.textoInformacoesSelecaoResponsavel }}
        </p>
        <el-link @click="openMoreInfo" :style="{color: corPrimaria }">MAIS INFORMAÇÕES</el-link>
        <el-dialog
          :visible.sync="openMore"
          title="Ajuda"
          :show-close="false"
          custom-class="custom-dialog-responsavel"
        >
          <span v-html="textos.textoMaisInformacoesSelecaoResponsavel" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import StepFormulario from '@/views/53/Steps/StepFormulario.vue'
import GrupoFamiliarBeneficiario from '@/views/53/components/GrupoFamiliarBeneficiario'
import { OmniMeetingResource } from '@/API'
export default {
  components: { StepFormulario, GrupoFamiliarBeneficiario },
  props: {
    idMeeting: {
      type: String
    },
    idAgenda: {
      type: Number
    },
    numeroContrato: {
      type: String
    }
  },
  data () {
    return {
      beneficiarioSelecionado: null,
      openMore: false
    }
  },
  watch: {
    beneficiarioSelecionado (value) {
      console.log(value)
    }
  },
  computed: {
    ...mapState('Func53', ['sucessoAgendamento']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Func53', ['tipoServico', 'idServico']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBtnPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBtnPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    textos () {
      return this.funcionalidade.parametros.textos
    },
    btnLabel () {
      return this.textos.labelBotaoConcluir
    },
    labelTipoServico () {
      if (this.idServico) {
        return this.tipoServico.find(item => item.idServico === this.idServico).descricao
      }
      return ''
    }
  },
  methods: {
    ...mapActions('Func53', ['setResponsavelAtendimento', 'setDadosContato']),
    async submitForm (dadosContato) {
      const res = await OmniMeetingResource.alterarResponsavel({
        idMeeting: this.idMeeting || this.sucessoAgendamento.meeting.idMeeting,
        nome: this.beneficiarioSelecionado.nome,
        chaveUnica: this.beneficiarioSelecionado.chaveUnica,
        dadosContato
      })
      if (!res || !res.status) {
        return
      }

      // Se a tela está componetizada, apenas emite um evento
      if (this.idMeeting) {
        this.$emit('changed')
      } else {
        this.setResponsavelAtendimento({
          nome: this.beneficiarioSelecionado.nome,
          contato: this.beneficiarioSelecionado.beneficiarioDados.dadosPessoais.contato,
          chaveUnica: this.beneficiarioSelecionado.chaveUnica,
          numeroContrato: this.beneficiarioSelecionado.numeroContrato,
          integracao: this.beneficiarioSelecionado.integracao || null
        })

        this.setDadosContato(dadosContato)

        this.nextStep()
      }
    },
    nextStep () {
      const step = this.beneficiarioSelecionado.permissoesApp && this.beneficiarioSelecionado.permissoesApp.canSendPushVoip ? 7 : 6.3
      this.$router.replace({ query: { step } })
    },
    openMoreInfo () {
      this.openMore = true
    }
  }
}
</script>
<style>
  .custom-dialog-responsavel .el-dialog__header {
    border-bottom: 1px solid #ddd;
  }
</style>
<style scoped lang="less">
  .caption-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: 5px;

    li {
      display: flex;
      align-items: center;

      .icon {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
</style>
